<template>
  <main class="grid max-w-sm mx-auto py-16 gap-8 justify-items-center">
    <img
      src="../assets/loan-waiting-illustration.png"
      alt="Failure"
      class="w-48"
      width="157"
      height="152"
    />
    <p class="text-center">
      <span class="font-bold">Please Wait <span class="blink_me">...</span></span>
      <br />We are verifying your details
    </p>
  </main>
  <!-- Spin Loader -->
  <spin-loader :spinLoading="isSpinLoading"/>
</template>
<script>
import { mapGetters } from 'vuex';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'KYC Result',
  computed: {
    ...mapGetters(['applicationId', 'skipBusinessProfileInReferral', 'flagsData', 'videoVerified', 'reKycStatus', 'flagsAllData', 'isGuarantor', 'guarantorData']),
  },
  components: {
    SpinLoader
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      isSpinLoading: undefined
    };
  },
  methods: {
    init() {
      if (this.isGuarantor) {
        this.getGuarantorDigilockerStatus();
      } else {
        this.homeFlags().then(() => {
          this.getDigilockerStatus();
        });
      }
    },
    getGuarantorDigilockerStatus() {
      this.isSpinLoading = true;
      this.$store
        .dispatch('guarantorDigilockerStatus', {
          loanId: this.guarantorData.loanId,
        })
        .then((response) => {
          this.isSpinLoading = false;
          if (response.success) {
            this.$router.push({ name: 'Guarantor KYC Success' });
          } else {
            this.$router.push({ name: 'Guarantor KYC Failure' });
          }
        })
        .catch(() => {
          this.isSpinLoading = false;
        });
    },
    getRouterLinkObject(routeName, modeCode, dName, rDirect) {
      return {
        name: routeName,
        query: {
          mode: modeCode,
          redirectRouteName: 'Loan Offers',
          displayName: dName,
          redirect: rDirect
        }
      };
    },
    homeFlags() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('homeFlags')
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            reject();
          });
      });
    },
    getDigilockerStatus() {
      this.$store
        .dispatch('signzyDigilockerStatus', {
          applicationId: this.applicationId,
        })
        .then((result) => {
          if (result.success) {
            if (this.reKycStatus) {
              this.$router.push({
                name: 'Video Verification',
                query: {
                    redirect: 'video-verification-signup',
                  },
              });
            } else if (localStorage.getItem('loanOfferRedirect') || (localStorage.getItem('routeName') === 'Loan Agreement')) {
              if (this.flagsAllData?.currentAddressRequired) {
                this.$router.push({
                  name: 'Personal Address',
                });
              } else if (!this.videoVerified && this.flagsData.faceVerificationEnabled) {
                this.$router.push(this.getRouterLinkObject('Redirect To Mandate', 'Video-verification', 'Video Verification', 'video-verification-loan-Offer'));
              }
            } else if (result.subStatus === "personalInfoUpdated") {
              if (this.flagsAllData?.currentAddressRequired) {
                this.$router.push({
                  name: 'Personal Address',
                });
              } else if (this.flagsData.faceVerificationEnabled && !this.videoVerified) {
                this.$router.push({
                  name: 'Video Verification',
                  query: {
                      redirect: 'video-verification-signup',
                    },
                });
              } else if (this.skipBusinessProfileInReferral) {
                this.getApprovals();
              } else {
                this.$router.push({ name: 'Pre Approval Step 3' });
              }
            } else if (result.subStatus === "businessInfoUpdated") {
              this.$router.push({ name: 'Pre Approval Review' });
            }
          } else {
            this.$router.push({ name: 'KYC Failure' });
          }
        })
        .catch(() => { });
    },
    getApprovals() {
      this.$store.dispatch('applicationApprovals', {
        applicationId: this.applicationId,
        urlParams: { option: 'best' },
      }).then((result) => {
        this.loading = false;
        if (result.showApproval) {
          this.$router.push({
            name: 'Pre Approval Congratulations',
            query: {
              nextRoute: 'Pre Approval Review',
            }
          });
        } else {
          this.$router.push({ name: 'Pre Approval Step 3' });
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
};
</script>
